<style lang="scss" scoped>
  @import "details";
  .search-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-form-item{
      margin-bottom:0;
    }
  }
  .record-details{
    display: flex;
    align-items: center;
    .title{
      width:150px;
      text-align: center;
    }
    dl{
      flex:1;
      border-left: 1px solid #E4E6EA;
      dd{
        height: 42px;
        line-height: 42px;
        border-bottom: 1px solid #E4E6EA;
        &:last-child{
          border: 0;
        }
      }
    }
  }
  .gene-details{
    display: flex;
    flex-wrap: wrap;
    padding:15px 30px 0;
    dd{
      width:23%;
      margin-bottom:15px;
      text-align: left;
      margin-right: 15px;
    }
  }
  @media screen and (max-width: 640px){
    .container{
      width: 90% !important;
      font-size: 12px!important;
    }
    .text-lists {
      display: block!important;
    }
    .text-lists li {
      width: 100% !important;
    }
    .container h3.title {
      font-size: 20px !important;
    }
  }
  @media screen and (max-width: 320px){
    .jiyin{
      margin-top: 10px;
    }
  }
</style>
<style lang="scss">
  .user-details .el-table__expanded-cell[class*=cell]{
    padding:0 !important;
  }
</style>
<template>
  <div class="user-details">
    <section class="container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/user' }">用户中心</el-breadcrumb-item>
        <el-breadcrumb-item><router-link to="/user/gene">基因合成订单</router-link></el-breadcrumb-item>
        <el-breadcrumb-item class="jiyin">基因合成订单详情</el-breadcrumb-item>
      </el-breadcrumb>
      <h3 class="title">基因合成订单详情<span :style="{fontSize: '14px', marginLeft: '20px', cursor: 'pointer'}"><a @click="viewContract">《服务协议》</a></span></h3>
      <ul class="text-lists">
        <li v-show="isHeadMan"><span>关联用户：</span>{{details.customerName}}</li>
        <li><span>订单创建者：</span>{{details.createUserName}}</li>
        <li><span>订单创建时间：</span>{{details.value.createTime | rTime}}</li>
        <li><span>实验基地：</span>{{details.baseName}}</li>
        <li><span>收货地址：</span>{{address}}</li>
      </ul>
      <div style="margin-top: 10px;">注：客户应自收到发票之日起3个月内支付费用，双方有其他约定的以另行约定为准</div>
      <el-table
        :header-cell-style="tableHeaderStyle"
        :cell-style="tableCellStyle"
        class="mt20"
        border
        :data="geneInfo">
        <el-table-column
          prop="value.no"
          label="订单编号">
        </el-table-column>
        <el-table-column
          label="订单金额（元）">
          <template slot-scope="scope">
            <span v-if="scope.row.value.amount">{{scope.row.value.amount | amount}}</span>
            <span v-else>待询价</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="geneNum"
          label="基因条数">
        </el-table-column>
        <el-table-column
          prop="okGeneNum"
          label="已合成条数">
        </el-table-column>
        <el-table-column
          prop="value.orderStatusName"
          label="订单状态">
        </el-table-column>
        <el-table-column
          prop="value.settlementStatusName"
          label="结算状态">
        </el-table-column>
        <el-table-column
          label="已结算金额（元）">
          <template slot-scope="scope">{{scope.row.value.amount | amount}}</template>
        </el-table-column>
        <el-table-column
          prop="value.shippedStatusName"
          label="配送状态">
        </el-table-column>
      </el-table>
      <h3 class="title">订单包含基因信息</h3>
      <el-table
        border
        class="mt20"
        :data="workOrders">
        <el-table-column
          type="expand">
          <template slot-scope="scope">
            <dl class="gene-details">
              <dd>基因名称：{{scope.row.name}}</dd>
              <dd>密码子优化：{{scope.row.codonOptimization ? '是' : '否'}}</dd>
              <dd>避免的酶切位点：{{scope.row.avoidedRestrictionSites}}</dd>
              <dd>交付量(ug)：{{scope.row.deliverNum ? baseMethods.qualityConverter(scope.row.deliverNum, 'ng', 'ug') : '-'}}</dd>
              <dd>克隆点位：{{scope.row.modify5}}/{{scope.row.modify3}}</dd>
              <dd>表达宿主：{{scope.row.expressionHost}}</dd>
              <dd>保留的酶切位点：{{scope.row.conservedEnzymeDigestion}}</dd>
<!--              <dd>序列：<span style="display: inline-block" v-html="scope.row.sequence"></span></dd>-->
              <dd>交付类型：{{scope.row.deliverType ? deliverTypeEnums[scope.row.deliverType] : '-'}}</dd>
              <dd class="d-flex flex-align-center">
                <el-tooltip placement="top">
                  <div slot="content" style="text-align: justify; width: 300px;">
                    <div style="margin-bottom: 10px;">序列：</div>
                    {{scope.row.sequence.substr(0, 500)}}
                    <div v-show="scope.row.sequence.length > 500" style="margin-top: 10px;">当前预览长度最大为500，如果浏览不全请点击“复制</div>
                  </div>
                  <div class="flex-1 text-ellipsis">序列：{{scope.row.sequence  | geneServiceType2(scope.row.sequence)}}</div>
                </el-tooltip>
                <el-button type="primary" size="small"
                           v-clipboard:copy="scope.row.sequence"
                           v-clipboard:success="onCopy"
                           v-clipboard:error="onError">复制</el-button>
              </dd>
              <dd>基因合成服务：{{scope.row.geneServiceType | geneServiceType1(scope.row.geneServiceType)}}</dd>
              <dd>序列类型：{{ scope.row.sequenceType }}</dd>
              <dd class="d-flex flex-align-center">
                <el-tooltip placement="top">
                  <div slot="content" style="text-align: justify; width: 300px;">
                    <div style="margin-bottom: 10px;"> 5‘侧翼序列：</div>
                    {{scope.row.flankingSequence5?scope.row.flankingSequence5.substr(0, 500):''}}
                    <div v-show="scope.row.flankingSequence5&&scope.row.flankingSequence5.length > 500" style="margin-top: 10px;">当前预览长度最大为500，如果浏览不全请点击“复制</div>
                  </div>
                  <div class="flex-1 text-ellipsis"> 5‘侧翼序列：{{scope.row.flankingSequence5  | geneServiceType2(scope.row.flankingSequence5)}}</div>
                </el-tooltip>
                <el-button  type="primary" size="small" style="margin-right: 15px;"
                            v-clipboard:copy="scope.row.flankingSequence5"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError" >复制</el-button>
              </dd>
              <dd class="d-flex flex-align-center">
                <el-tooltip placement="top">
                  <div slot="content" style="text-align: justify; width: 300px;">
                    <div style="margin-bottom: 10px;">3‘侧翼序列：</div>
                    {{scope.row.flankingSequence3?scope.row.flankingSequence3.substr(0, 500):''}}
                    <div v-show="scope.row.flankingSequence3&&scope.row.flankingSequence3.length > 500" style="margin-top: 10px;">当前预览长度最大为500，如果浏览不全请点击“复制</div>
                  </div>
                  <div class="flex-1 text-ellipsis"> 3‘侧翼序列：{{scope.row.flankingSequence3  | geneServiceType2(scope.row.flankingSequence3)}}</div>
                </el-tooltip>
                <el-button type="primary" size="small"
                           v-clipboard:copy="scope.row.flankingSequence3"
                           v-clipboard:success="onCopy"
                           v-clipboard:error="onError">复制</el-button>
              </dd>
            </dl>
          </template>
        </el-table-column>
        <el-table-column
          prop="geneOrder.no"
          label="子订单号">
        </el-table-column>
        <el-table-column
          prop="name"
          label="基因名称">
        </el-table-column>
        <el-table-column
          label="单价（元）">
          <template slot-scope="scope">
            <span v-if="scope.row.charges">{{scope.row.charges | amount}}</span>
            <span v-else>待询价</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="workOrderStatusName"
          label="合成状态">
        </el-table-column>
        <el-table-column
          prop="shippedStatusName"
          label="配送状态">
        </el-table-column>
        <el-table-column
          prop="settlementStatusName"
          label="结算状态">
        </el-table-column>
      </el-table>
      <h3 class="title distribution-title" @click="showDistribution = !showDistribution">配送记录<span class="el-icon-arrow-down" :class="{active: !showDistribution}"></span></h3>
      <div v-show="showDistribution">
        <el-table
          :data="sendLists"
          border>
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="record-details">
                <div class="title">基因名称</div>
                <dl>
                  <dd v-for="item in scope.row.items" :key="item.id">{{item.goodsName}}</dd>
                </dl>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="配送单号"
            prop="code">
          </el-table-column>
          <el-table-column
            prop="sendStatusName"
            label="配送状态">
          </el-table-column>
          <el-table-column
            label="配送方式"
            prop="sendTypeName">
          </el-table-column>
          <el-table-column
            label="配送员/运单号">
            <template slot-scope="scope">
              <div v-if="scope.row.sendType === 'SENDER'">{{scope.row.sender && scope.row.sender.realName}}</div>
              <div v-else>{{scope.row.deliveryCode}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="配送完成时间">
            <template slot-scope="scope">{{scope.row.finishSendDate | rTime}}</template>
          </el-table-column>
        </el-table>
        <div class="page tr">
          <el-pagination
            :page-size="10"
            :pager-count="10"
            layout="prev, pager, next"
            :total="sendTotal"
            @current-change="changeSendPage">
          </el-pagination>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { geneOrdersDetails, geneWorkOrder, primerSendOrders, sendOrdersDetails } from '@/services/api.index'
import { deliverTypeEnums} from "../../constants/enums";
import {
  tableHeaderStyle,
  tableCellStyle
} from '@/settings/table'
export default {
  data () {
    return {
      deliverTypeEnums,
      tableHeaderStyle,
      tableCellStyle,
      geneId: this.$route.query.id,
      details: {},
      address: '',
      geneInfo: [],
      workOrders: [],
      showDistribution: true,
      sendLists: [],
      sendTotal: 0,
      sendPage: 0,
      sendSize: 10,
      isHeadMan: this.baseMethods.isHeadMan(),
      subOrderList: []
    }
  },
  created() {
    this.getDetails()
    this.getWorkOrders()
  },
  filters:{
    geneServiceType1(data){
      if(data === 'STANDARD'){
        return '标准基因合成'
      }
      if(data === 'SPEED'){
        return '快速基因合成'
      }
      if(data === 'ET_GENE'){
        return 'ETgene'
      }
    },
    geneServiceType2(data){
      return data?data.slice(0,4):''
    }
  },
  methods: {
    // 订单详情
    getDetails () {
      geneOrdersDetails(this.geneId).then(res => {
        this.details = res.data
        let value = res.data.value
        value.orderStatusName = this.baseMethods.orderStatus(res.data.userWebOrderStatus)
        value.settlementStatusName = this.baseMethods.settlementGeneStatus(value.settlementStatus)
        value.shippedStatusName = this.baseMethods.shippedGeneStatus(res.data.userWebShippedStatus)
        this.geneInfo = this.geneInfo.concat(res.data)
        this.address = `${value.raProvince}${value.raCity}${value.raCounty} ${value.raAddress}`
      })
    },
    viewContract() {
      window.open(process.env.SHOP_URL + `/article/detail/14_0`)
    },
    // 订单包含基因
    getWorkOrders () {
      geneWorkOrder(this.geneId).then(res => {
        const orderNoList = []
        res.data.map(item => {
          item.workOrderStatusName = this.baseMethods.workOrderStatus(item.status)
          item.settlementStatusName = this.baseMethods.settlementStatus(item.geneOrder.settlementStatus)
          item.shippedStatusName = this.baseMethods.shippedGeneStatus(item.sendStatus)
          if(item.sequenceType !== 'DNA') {
            item.sequence = item.proteinSequence
          }
          item.sequence = item.sequence.replace(/<p>/gi,'')
          item.sequence = item.sequence.replace(/<br>/gi,'')
          item.sequence = item.sequence.replace(/<\/p>/gi,'')
          orderNoList.push(item.geneOrder.no)
        })
        this.subOrderList = [...new Set(orderNoList)]
        this.getSendOrders()
        this.workOrders = res.data
      })
    },
    // 配送记录
    getSendOrders () {
      const { sendPage, sendSize, details } = this
      let key = ''
      const params = {
        page: sendPage,
        size: sendSize
      }
      key = this.subOrderList.length === 1 ? 'orderCode' : 'orderCodes'
      params[key] = this.subOrderList.join()
      primerSendOrders(params).then(async res => {
        await Promise.all(res.data.map(async item => {
          item.sendStatusName = this.baseMethods.sendStatus(item.sendStatus)
          item.sendTypeName = this.baseMethods.sendType(item.sendType)
          item.items = item.items = (await sendOrdersDetails(item.id)).data
        }))
        this.sendLists = res.data
        this.sendTotal = this.baseMethods.getTotal(res)
      })
    },
    // 复制序列号
    onCopy () {
      this.$message.success('复制成功！')
    },
    onError () {
      this.$message.error('复制失败！')
    },
    // 翻页
    changeSendPage (value) {
      this.sendPage = value - 1
      this.getSendOrders()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/gene_details.vue